/**
 * Value in range 0.0 ... 1.0.
 */
export let ContactDuplicateSuggestion;
(function (_ContactDuplicateSuggestion) {
  let Status = /*#__PURE__*/function (Status) {
    Status["UNSEEN"] = "unseen";
    Status["ACCEPTED"] = "accepted";
    Status["DECLINED"] = "declined";
    return Status;
  }({});
  _ContactDuplicateSuggestion.Status = Status;
  function isUnseen(arg) {
    if (arg !== null && typeof arg === 'object') {
      return arg.status === Status.UNSEEN;
    }
    return arg === Status.UNSEEN;
  }
  _ContactDuplicateSuggestion.isUnseen = isUnseen;
  function isAccepted(arg) {
    if (arg !== null && typeof arg === 'object') {
      return arg.status === Status.ACCEPTED;
    }
    return arg === Status.ACCEPTED;
  }
  _ContactDuplicateSuggestion.isAccepted = isAccepted;
  function isDeclined(arg) {
    if (arg !== null && typeof arg === 'object') {
      return arg.status === Status.DECLINED;
    }
    return arg === Status.DECLINED;
  }
  _ContactDuplicateSuggestion.isDeclined = isDeclined;
})(ContactDuplicateSuggestion || (ContactDuplicateSuggestion = {}));